import { Link, NavLink } from "react-router-dom";

function Header() {
  return (
    <>
      <nav className="navbar navbar-expand-lg py-1 px-0 sticky-top my-header-bg z-5">
        <div className="container">
          <div className="d-flex align-items-center">
            <button
              class="navbar-toggler collapsed me-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar-default"
              aria-controls="navbar-default"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="icon-bar top-bar mt-0"></span>
              <span class="icon-bar middle-bar"></span>
              <span class="icon-bar bottom-bar"></span>
            </button>

            <Link to="/">
              <img
                src="/assets/images/logo.png"
                className="d-lg-none d-block"
                width="70"
              />
              <img
                src="/assets/images/logo.png"
                width="80"
                className="me-5 d-lg-block d-none"
              />
            </Link>
          </div>
          <div className="ms-auto d-flex align-items-center order-lg-3">
            <div>
              <div className="d-flex align-items-center">
                <div class="d-flex gap-2 align-items-center justify-content-end me-lg-7 me-5">
                  <i className="bi bi-facebook text-dark fs-4 me-3"></i>
                  <i className="bi bi-instagram text-dark fs-4 me-3"></i>
                  <i className="bi bi-twitter text-dark fs-4 me-3"></i>
                  <i className="bi bi-youtube text-dark fs-4 d-lg-block d-none"></i>
                </div>

                <Link
                  to="/"
                  className="btn bg-green fw-normal shadow-sm me-lg-1 px-4 text-white"
                >
                  Join Us
                </Link>
                <Link
                  to="/become-ambassador"
                  className="btn bg-primary text-white fw-normal d-none d-md-block me-2 px-4 me-lg-0"
                >
                  Become Ambassador
                </Link>
              </div>
            </div>
          </div>
          <div className="collapse navbar-collapse" id="navbar-default">
            <ul className="navbar-nav  mt-3 mt-lg-0">
              <li className="nav-item">
                <NavLink to="/" className="nav-link ps-0">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/why-microfinance" className="nav-link">
                  Why Microfinancebazar
                </NavLink>
              </li>
              <li className="nav-item">
                <a className="nav-link">Our Work</a>
              </li>
              <li className="nav-item">
                <NavLink to="/about" className="nav-link">
                  About Us
                </NavLink>
              </li>
              <li className="nav-item">
                <a className="nav-link">News</a>
              </li>
              <li className="nav-item">
                <NavLink to="/faq" className="nav-link">
                  FAQs
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
